// extracted by mini-css-extract-plugin
export default {"genericCard":"Xr-z","inline":"Yr-z","mastercard":"Zr-z","discover":"_r-z","visa":"as-z","amex":"bs-z","active":"cs-z"};